import { ConfigSentryF } from '../../../../../../modules/Config/Sentry/F/Function/module/ConfigSentryF.js';

ConfigSentryF.main();
